import { Store } from "@ngrx/store";
import { resetAdmissionDate } from '../kiosk/components/admission-date/state/admission-date.action';
import { admissionDateFeatureKey, AdmissionDateState } from "../kiosk/components/admission-date/state/admission-date.reducer";
import { resetAgreement } from '../kiosk/components/agreement/state/agreement.actions';
import { agreementFeatureKey, AgreementState } from "../kiosk/components/agreement/state/agreement.reducer";
import { resetArchospi } from '../kiosk/components/archospi/state/archospi.actions';
import { arcHospiFeatureKey, ArcHospiState } from '../kiosk/components/archospi/state/archospi.reducer';
import { resetAuthentication } from '../kiosk/components/authentication/state/authentication.actions';
import { authenticationFeatureKey, AuthenticationState } from "../kiosk/components/authentication/state/authentication.reducer";
import { resetCity } from '../kiosk/components/city/state/city.actions';
import { cityFeatureKey, CityState } from "../kiosk/components/city/state/city.reducer";
import { contractFeatureKey, ContractState } from "../kiosk/components/contract/state/contract.reducer";
import { resetError } from '../kiosk/components/error/state/error.actions';
import { errorFeatureKey, ErrorState } from "../kiosk/components/error/state/error.reducer";
import { resetHospi } from "../kiosk/components/hospi/state/hospi.actions";
import { hospiFeatureKey, HospitalizationState } from "../kiosk/components/hospi/state/hospi.reducer";
import { resetInsurer } from '../kiosk/components/insurer/state/insurer.actions';
import { insurerFeatureKey, InsurerState } from "../kiosk/components/insurer/state/insurer.reducer";
import { resetLanguage } from '../kiosk/components/language/state/language.actions';
import { languageFeatureKey, LanguageState } from "../kiosk/components/language/state/language.reducer";
import { resetMaintenance } from '../kiosk/components/maintenance/state/maintenance.actions';
import { maintenanceFeatureKey, MaintenanceState } from '../kiosk/components/maintenance/state/maintenance.reducer';
import { resetProvince } from '../kiosk/components/province/state/province.actions';
import { provinceFeatureKey, ProvinceState } from "../kiosk/components/province/state/province.reducer";
import { questionFeatureKey, QuestionState } from "../kiosk/components/question/state/question.reducer";
import { resetSite } from "../kiosk/components/site/state/site.actions";
import { siteFeatureKey, SiteState } from "../kiosk/components/site/state/site.reducer";
import { resetSpinner } from '../kiosk/components/spinner/state/spinner.actions';
import { titleFeatureKey, TitleState } from '../kiosk/components/title/state/title.reducer';
import { resetTransactionInfo } from "../kiosk/components/transaction-info/state/transaction-info.actions";
import { transactionInfoFeatureKey, TransactionInfoState } from "../kiosk/components/transaction-info/state/transaction-info.reducer";
import { kioskFeatureKey, KioskState } from '../kiosk/state/kiosk.reducer';
import { Observable } from "rxjs";

export interface AppState {
	[transactionInfoFeatureKey]: TransactionInfoState;
	[errorFeatureKey]: ErrorState;
	[languageFeatureKey]: LanguageState;
	[insurerFeatureKey]: InsurerState;
	[contractFeatureKey]: ContractState;
	[agreementFeatureKey]: AgreementState;
	[provinceFeatureKey]: ProvinceState;
	[cityFeatureKey]: CityState;
	[questionFeatureKey]: QuestionState;
	[authenticationFeatureKey]: AuthenticationState;
	[hospiFeatureKey]: HospitalizationState;
	[admissionDateFeatureKey]: AdmissionDateState;
	[arcHospiFeatureKey]: ArcHospiState;
	[kioskFeatureKey]: KioskState;
	[titleFeatureKey]: TitleState;
	[maintenanceFeatureKey]: MaintenanceState;
	[siteFeatureKey]: SiteState;
}


export function getState(store: Store<AppState>): Observable<AppState> {
  return store.select(state => state);
}

export function resetStates(store: Store<AppState>):void {
	store.dispatch(resetAuthentication());
	store.dispatch(resetTransactionInfo());
	store.dispatch(resetLanguage());
	store.dispatch(resetInsurer());
	store.dispatch(resetAdmissionDate());
	store.dispatch(resetAgreement());
	store.dispatch(resetArchospi());
	store.dispatch(resetError());
	store.dispatch(resetProvince());
	store.dispatch(resetCity());
	store.dispatch(resetSpinner());
	store.dispatch(resetMaintenance());
	store.dispatch(resetSite());
	store.dispatch(resetHospi());
}